import type { TextElement as TextElementType } from "@/react/types/Element";
import { Typography } from "@circle-react-uikit/Typography";

interface TextElementProps {
  element: TextElementType;
}
export const TextElement = ({ element }: TextElementProps) => {
  if (!element.attributes.value) {
    return null;
  }

  const TypographyComponent =
    element.attributes.text_type === "title"
      ? Typography.TitleMd
      : element.attributes.text_type === "subtitle"
        ? Typography.TitleSm
        : element.attributes.text_type === "paragraph"
          ? Typography.BodySm
          : Typography.TitleMd; // Default to title any unknown text_type
  return (
    <div className="mb-2">
      <TypographyComponent>{element.attributes.value}</TypographyComponent>
    </div>
  );
};
